import clsx from 'clsx'
import React, { Dispatch } from 'react'
import { Control, Controller } from 'react-hook-form'

import s from './styles.module.scss'

import { HouseSearchFiltersType } from '../house-search.types'
import { Transport_Type } from '../../../../lib/graphql'
import { Icon } from '../../../atoms'
import { ISearchFormProps } from '../../../templates/house-search-layout/HouseSearchLayout'

interface IHouseSearchFilterProps {
  control: Control<ISearchFormProps, any>
  filters: HouseSearchFiltersType[]
  minBudgetValue: number
  maxBudgetValue: number
  setTransientValueMin: Dispatch<React.SetStateAction<number>>
  setTransientValueMax: Dispatch<React.SetStateAction<number>>
  setTransportType: Dispatch<React.SetStateAction<Transport_Type>>
  className?: string
}

export const HouseSearchFilters = ({
  control,
  filters,
  minBudgetValue,
  maxBudgetValue,
  setTransientValueMin,
  setTransientValueMax,
  setTransportType,
  className,
}: IHouseSearchFilterProps) => {
  return (
    <>
      {filters.map((filter) => (
        <Controller
          key={filter.name}
          control={control}
          name={filter.name}
          render={({ field }) => (
            <div className={clsx(s.filterContainer, className)}>
              <div className={s.label}>{filter.label}</div>
              <Icon
                name='cross'
                onClick={() => {
                  if (filter.name === 'budget') {
                    setTransientValueMin(minBudgetValue)
                    setTransientValueMax(maxBudgetValue)
                    field.onChange({
                      budgetMin: minBudgetValue,
                      budgetMax: maxBudgetValue,
                    })
                  } else if (filter.name === 'travelTime') {
                    setTransportType(Transport_Type.DRIVING)
                    field.onChange({
                      travelTime: {
                        transportTime: undefined,
                        transportType: Transport_Type.DRIVING,
                      },
                    })
                  } else {
                    field.onChange(undefined)
                  }
                }}
                size={12}
                className={s.icon}
              />
            </div>
          )}
        />
      ))}
    </>
  )
}
